<template>
	<detail view :id="id"></detail>
</template>

<script>
	import detail from './product_edit.vue'
	
	export default {
		props: {
			id: String
		},
		
		components: {
			detail
		}
	}
</script>